// Created by hejikun on 2017/10/25 0025.
import Vue from 'vue'
import { Base64 } from 'js-base64'
import config from '../../library/config'
import { getUserInfo } from '@/apis/fromBaseApi/user'

let state = {
  openId: '',
  onLoading: false,
  homePage: {},
  dep_scrollTop: 0,
  hos_scrollTop: 0,
  reg_date: '2017-2-20'
}
function getUrlParam(name) {
  let reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`)
  let r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURIComponent(r[2])
  }
  return null
}

/**
 * 套壳小程序中的openid补录
 */
function miniappWebViewUserBind() {
  const cururl = window.location.href
  let userDetail = Base64.decode(localStorage.getItem('authtoken').split('.')[1])
  userDetail = JSON.parse(userDetail)
  // 判断该用户是否进行过微信授权，三方用户表中是否存在微信openId
  if (userDetail.mock_openid) {
    // 若不存在则发起授权
    let url = cururl + (cururl.indexOf('app.ynhdkc.com') > -1 ? '' : (cururl.indexOf('?') > -1 ? '&' : '?') + 'env=appv2test')
    const redirectUri = encodeURIComponent(
      document.location.protocol +
        '//vote.ynhdkc.com/wechat/api/v1/miniapp-bind?weburl=' +
        encodeURIComponent(url) +
        '&miniOpenid=' +
        userDetail.mini_openid
    )
    if (!/\/transfer_[login|admin|detail]/.test(location.href)) {
      window.location.href =
        'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx337dd7b0a2de2ca4&redirect_uri=' +
        redirectUri +
        '&response_type=code&scope=snsapi_base&state=1#wechat_redirect'
    }
  } else {
    // 若存在则跳转回原页面
    window.location.href = cururl
  }
}
const actions = {
  // 获取用户信息
  loadUserData({ commit }) {
    if (!localStorage.getItem('authtoken')) {
      return
    }
    let authinfo = localStorage.getItem('authtoken')
    let openId = ''
    let newOpenid = ''
    let newSubscribe = ''
    let authDetail = JSON.parse(Base64.decode(authinfo.split('.')[1]))
    if (authinfo) {
      openId = authDetail.openid
      newOpenid = authDetail.new_openid
      newSubscribe = authDetail.new_subscribe ? authDetail.new_subscribe : 0
      Vue.prototype.hina.track('H_SignUp', {
        wx_old_openid: authDetail.openid,
        wx_new_openid: authDetail.new_openid,
        wx_mini_openid: authDetail.mini_openid,
        wx_union_id: authDetail.union_id
      })
      Vue.prototype.hina.setUserUId(authDetail.user_id)
      // Vue.prototype.aegis.setConfig({
      //   uin: authDetail.user_id
      // })
    }
    const platform = sessionStorage.getItem('platform')
    commit('SET_OPEN_ID', openId)
    return new Promise((resolve, reject) => {
      if (platform === 'dytminiapp' && authDetail.mock_openid) {
        miniappWebViewUserBind()
        return
      }
      if (openId || newOpenid) {
        // const time = new Date().getTime()
        // let url = ''
        // if (config.useNewPay) {
        //   // if (newSubscribe) {
        //   url = `https://vote.ynhdkc.com/wechat/api/v2/info/${newOpenid}?t=${time}`
        // } else {
        //   url = `https://vote.ynhdkc.com/wechat/api/v1/info/${openId}?t=${time}`
        // }
        getUserInfo({
          authorization: localStorage.getItem('authtoken').data
        })
          .then((res) => {
            if (res && res.status == 200) {
              const data = JSON.parse(res.data.jwt)
              const userRealNewSubscribe = data.new_subscribe ? data.new_subscribe : 0
              if (userRealNewSubscribe !== newSubscribe) {
                localStorage.removeItem('authtoken')
                location.reload()
              }
              commit('SET_USER_DETAIL', data)
              Vue.prototype.$wechat_id = data.wechat_id
              Vue.prototype.$user_id = data.user_id
              Vue.prototype.$userDetail = data
              Vue.prototype.$mini_openid = data.mini_openid
              Vue.prototype.$alipay_user_id = data.alipay_user_id
              Vue.prototype.hina.track('H_SignUp', {
                wx_old_openid: data.openid,
                wx_new_openid: data.new_openid,
                wx_mini_openid: data.mini_openid,
                wx_union_id: data.union_id
              })
              Vue.prototype.hina.setUserUId(data.user_id)
              // Vue.prototype.$userStatus = data.status
              resolve(data)
            }
            // const userRealNewSubscribe = res.data.data.newSubscribe ? res.data.data.newSubscribe : 0
            // if (userRealNewSubscribe !== newSubscribe) {
            //   localStorage.removeItem('authtoken')
            //   location.reload()
            // }
            // if (res.data.code !== 1) {
            //   reject(res.data.msg)
            // }
            // commit('SET_USER_DETAIL', res.data.data)
            // // 存储一些常用数据
            // Vue.prototype.$wechat_id = res.data.data.wechat_id
            // Vue.prototype.$user_id = res.data.data.user_id
            // Vue.prototype.$userDetail = res.data.data
            // Vue.prototype.$userStatus = res.data.data.status
            // resolve(res.data.data)
          })
          .catch((e) => {
            reject(e)
          })
      } else {
        getUserInfo({
          authorization: localStorage.getItem('authtoken').data
        }).then((res) => {
          if (res && res.status == 200) {
            const data = JSON.parse(res.data.jwt)
            const userRealNewSubscribe = data.new_subscribe ? data.new_subscribe : 0
            if (userRealNewSubscribe !== newSubscribe) {
              localStorage.removeItem('authtoken')
              location.reload()
            }
            commit('SET_USER_DETAIL', data, 12312)
            Vue.prototype.$wechat_id = data.wechat_id
            Vue.prototype.$user_id = data.user_id
            Vue.prototype.$userDetail = data
            Vue.prototype.$mini_openid = data.mini_openid
            Vue.prototype.$alipay_user_id = data.alipay_user_id
            Vue.prototype.hina.track('H_SignUp', {
              wx_old_openid: data.openid,
              wx_new_openid: data.new_openid,
              wx_mini_openid: data.mini_openid,
              wx_union_id: data.union_id
            })
            Vue.prototype.hina.setUserUId(data.user_id)
            // Vue.prototype.$userStatus = data.status
            resolve(data)
          }
          // const userRealNewSubscribe = res.data.data.newSubscribe ? res.data.data.newSubscribe : 0
          // if (userRealNewSubscribe !== newSubscribe) {
          //   localStorage.removeItem('authtoken')
          //   location.reload()
          // }
          // if (res.data.code !== 1) {
          //   reject(res.data.msg)
          // }
          // commit('SET_USER_DETAIL', res.data.data)
          // // 存储一些常用数据
          // Vue.prototype.$wechat_id = res.data.data.wechat_id
          // Vue.prototype.$user_id = res.data.data.user_id
          // Vue.prototype.$userDetail = res.data.data
          // Vue.prototype.$userStatus = res.data.data.status
          // resolve(res.data.data)
        })
      }
    })
  },
  // 获取用户信息
  // reaouth() {
  //   let platform = sessionStorage.getItem('platform')
  //   if (platform === 'dytminiapp') {
  //     if (localStorage.getItem('dzjkk')) {
  //       localStorage.removeItem('dzjkk')
  //       window.wx.miniProgram.navigateTo({
  //         url: `/pages/yunnancn/yunnancn`
  //       })
  //     } else {
  //       window.wx.miniProgram.navigateTo({
  //         url: `/pages/index/index`
  //       })
  //     }
  //     return
  //   }
  //   let cururl = window.location.href
  //   let from = getUrlParam('wechat_login')
  //   let url = cururl + (cururl.indexOf('app.ynhdkc.com') > -1 ? '' : (cururl.indexOf('?') > -1 ? '&' : '?') + 'env=appv2test')
  //   let authinfo = localStorage.getItem('authtoken')
  //   let authDetail = JSON.parse(Base64.decode(authinfo.split('.')[1]))
  //   localStorage.removeItem('authtoken')
  //   if (authDetail.new_openid) {
  //     let redirectUri = encodeURIComponent(
  //       document.location.protocol + '//vote.ynhdkc.com/wechat/api/v2/login?weburl=' + encodeURIComponent(url) + (from ? '&wechat_login=' + from : '')
  //     )
  //     location.assign(
  //       `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx324860af71b94a93&redirect_uri=${redirectUri}&response_type=code&scope=${
  //         from ? 'snsapi_userinfo' : 'snsapi_base'
  //       }&state=1#wechat_redirect`
  //     )
  //   } else {
  //     let redirectUri = encodeURIComponent(
  //       document.location.protocol + '//vote.ynhdkc.com/wechat/api/v1/login?weburl=' + encodeURIComponent(url) + (from ? '&wechat_login=' + from : '')
  //     )
  //     location.assign(
  //       `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx337dd7b0a2de2ca4&redirect_uri=${redirectUri}&response_type=code&scope=${
  //         from ? 'snsapi_userinfo' : 'snsapi_base'
  //       }&state=1#wechat_redirect`
  //     )
  //   }
  // },
  // 获取用户信息
  reaouth_home() {
    let platform = sessionStorage.getItem('platform')
    let platUserId = sessionStorage.getItem('platUserId')
    let cururl = navigator.userAgent.indexOf('iPhone') === -1 ? window.location.href : localStorage.getItem('DA-LANDPAGE')
    let authinfo = localStorage.getItem('authtoken')
    let authDetail
    if (authinfo) {
      authDetail = JSON.parse(Base64.decode(authinfo.split('.')[1]))
    }
    localStorage.removeItem('authtoken')
    if (navigator.userAgent.indexOf('Alipay') > -1 || navigator.userAgent.indexOf('AlipayClient') > -1) {
      // eslint-disable-next-line no-undef
      my.navigateTo({
        url: `/pages/index/index`
      })

      return
    }

    if (platform === 'dytminiapp') {
      if (localStorage.getItem('dzjkk')) {
        localStorage.removeItem('dzjkk')
        window.wx.miniProgram.navigateTo({
          url: `/pages/yunnancn/yunnancn`
        })
      } else {
        window.wx.miniProgram.navigateTo({
          url: `/pages/index/index`
        })
      }
    } else if (platUserId && platform) {
      window.location.reload()
    } else {
      let from = getUrlParam('wechat_login')
      let fromCsfw = sessionStorage.getItem('fromCsfw')
      let url = cururl
      const channel = localStorage.getItem('channel')

      if (authDetail && authDetail.new_openid && channel == '2') {
        let redirect_uri = encodeURIComponent(
          `${document.location.protocol}//vote.ynhdkc.com/apis/v1/user/session/users/wechat_callback?redirect=${encodeURIComponent(
            url
          )}&channel=${channel}`
        )
        location.assign(
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx324860af71b94a93&redirect_uri=${redirect_uri}&response_type=code&scope=${
            from ? 'snsapi_userinfo' : 'snsapi_base'
          }&state=1#wechat_redirect`
        )
      } else {
        let redirect_uri = encodeURIComponent(
          `${document.location.protocol}//vote.ynhdkc.com/apis/v1/user/session/users/wechat_callback?redirect=${encodeURIComponent(
            url
          )}&channel=${channel}`
        )
        location.assign(
          `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx337dd7b0a2de2ca4&redirect_uri=${redirect_uri}&response_type=code&scope=${
            from ? 'snsapi_userinfo' : 'snsapi_base'
          }&state=1#wechat_redirect`
        )
      }
    }
  },
  // 获取首页数据
  loadHomeData({ commit }) {
    return new Promise((resolve, reject) => {
      window.newDytApiBaseApi
        .get('/index/api/v1/common/homepage')
        .then((res) => {
          if (res.data.code !== 1) {
            reject(res.data.msg)
          }
          commit({
            type: 'SET_HOME_PAGE',
            data: res.data.data
          })
          resolve(res.data.data)
        })
        .catch((e) => {
          reject(e)
        })
    })
  },
  // 设置 loading
  setLoading({ commit }, state) {
    commit('SET_LOADING', state)
  }
}

const getters = {}

const mutations = {
  SET_OPEN_ID(state, arg) {
    state.openId = arg
  },
  SET_USER_DETAIL(state, arg) {
    state.userDetail = arg
  },
  SET_LOADING(state, arg) {
    state.onLoading = arg
  },
  SET_HOME_PAGE(state, data) {
    state.homePage = data.data
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
